// extracted by mini-css-extract-plugin
export default {"aside":"styles_aside__w9Qzi","activeLink":"styles_activeLink__akgtP"};